import { useMemo } from 'react';

export const useIsIos = () => {
	return useMemo(() => {
		return /(?=.*\bAppleWebKit\b)(?=.*\b(iPhone|iPad|iPod)\b)/.test(navigator.userAgent);
	}, []);
};
